import { useSelector } from 'react-redux';
import en from '../global/locales/en/main.json';
import ja from '../global/locales/ja/main.json';
import { getSafeValue } from '../utils/security';
import { RootState } from '../store';

const allTranslations = { en, ja };

const useTranslations = () => {
  const user = useSelector((state: RootState) => state.user);
  const language = user?.language ?? 'en';
  const { units: _units, ...translations } = getSafeValue(allTranslations, language) ?? allTranslations.en;
  return translations;
};

export default useTranslations;


